export default __webpack_public_path__ + "static/media/202-taiwan.e6ee8626.svg";